function parseData(data) {
  if (!data) {
    return null;
  } else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {

  const getConsentRequest = ({ inputParam, metaData }) =>
    api.getConsentRequest(inputParam, metaData)
      .then(parseData)
      .catch((error) => {
        const data = {
          body:error.body,
          statusCode: error.statusCode
        }
        return parseData(data);
    })

  const getAISConsent = ({ inputParam, metaData }) =>
    api.getAISConsent(inputParam, metaData)
      .then(parseData)
      .catch((error) => {
        const data = {
          body:error.body,
          statusCode: error.statusCode
        }
        return parseData(data);
    })

  const consentUpdate = ({ inputParam, metaData }) =>
    api.consentUpdate(inputParam, metaData)
      .then(parseData)
      .catch((error) => {
        const data = {
          body:error.body,
          statusCode: error.statusCode
        }
        return parseData(data);
    })

  return {
    getConsentRequest,
    getAISConsent,
    consentUpdate
  }
}

module.exports = serviceFactory;